export const USER_ACTIONS = "USER_ACTIONS";

export const userAction = () => {
  return {
    type: USER_ACTIONS,
  };
};
